import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { pinyin } from "pinyin-pro";
export const formateOrgTree = org => {
  return org.map(item => {
    if (item.children) {
      return {
        ...item,
        label: item.name,
        value: item.orgId,
        children: formateOrgTree(item.children)
      };
    } else {
      return {
        ...item,
        label: item.name,
        value: item.orgId
      };
    }
  });
};
export const findPathByOrgTree = (tree, target, path = []) => {
  for (let index = 0; index < tree.length; index++) {
    const node = tree[index];
    if (node.orgId == target) {
      return [...path, node.orgId];
    } else {
      // 如果有子节点，递归查找
      if (node.children && node.children.length) {
        const foundPath = findPathByOrgTree(node.children, target, [...path, node.orgId]);
        if (foundPath) return foundPath;
      }
    }
  }
};
export const copyToClipboard = async text => {
  try {
    // 方法1: 使用现代 Clipboard API
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }

    // 方法2: 兼容旧浏览器的备用方案
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed"; // 避免滚动到底部
    document.body.appendChild(textarea);
    textarea.select();
    const result = document.execCommand("copy");
    document.body.removeChild(textarea);
    if (!result) {
      throw new Error($t("bktvvh4", "复制失败"));
    }
    return true;
  } catch (err) {
    console.error("复制失败:", err);
    return false;
  }
};
// 根据传来的中英文混合字符串，返回中文取首拼英字母，英文原样保留
export const getFirstLetter = str => {
  let result = "";
  for (let index = 0; index < str.length; index++) {
    const char = str[index];
    if (/[\u4e00-\u9fa5]/.test(char)) {
      // 检查是否是汉字
      // 使用pinyin-match获取拼音首字母
      const match = pinyin(char, {
        toneType: "none"
      })[0];
      if (match && match.length > 0) {
        result += match[0].toUpperCase();
      }
    } else {
      // 非汉字字符直接保留
      result += char.toUpperCase();
    }
  }
  return result;
};